function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 7.08333C16.5658 7.08333 18.0964 7.54764 19.3983 8.41753C20.7002 9.28743 21.7149 10.5238 22.314 11.9704C22.9132 13.417 23.07 15.0088 22.7646 16.5445C22.4591 18.0801 21.7051 19.4908 20.5979 20.5979C19.4908 21.7051 18.0801 22.4591 16.5445 22.7645C15.0088 23.07 13.417 22.9132 11.9704 22.314C10.5238 21.7148 9.28743 20.7002 8.41754 19.3983C7.54764 18.0964 7.08334 16.5658 7.08334 15C7.08554 12.901 7.92033 10.8887 9.40451 9.40451C10.8887 7.92032 12.901 7.08554 15 7.08333V7.08333ZM15 6C13.22 6 11.4799 6.52784 9.99987 7.51677C8.51983 8.50571 7.36628 9.91131 6.68509 11.5558C6.0039 13.2004 5.82567 15.01 6.17294 16.7558C6.5202 18.5016 7.37737 20.1053 8.63604 21.364C9.89471 22.6226 11.4984 23.4798 13.2442 23.8271C14.99 24.1743 16.7996 23.9961 18.4442 23.3149C20.0887 22.6337 21.4943 21.4802 22.4832 20.0001C23.4722 18.5201 24 16.78 24 15C24 12.613 23.0518 10.3239 21.364 8.63604C19.6761 6.94821 17.3869 6 15 6V6Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.93 22.3698C15.6516 10.6881 12.3733 7.20312 12.3733 7.20312",
  stroke: "white",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.32324 13.8265C6.32324 13.8265 17.2666 14.8148 20.9032 9.27148",
  stroke: "white",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28833 21.0832C9.28833 21.0832 13.3233 12.9749 23.6117 15.4716",
  stroke: "white",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14,
  stroke: "white",
  strokeWidth: 2
});

var SvgIconDribbble2 = function SvgIconDribbble2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDribbble2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dribbble2.4a66f830.svg";
export { ForwardRef as ReactComponent };